module.exports = __webpack_public_path__ + "img/gongcyj.aa16a489.png";